import { Page } from '@/core/architecture'

import { ResaleRaffleRepaymentCompletionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleRaffleRepaymentCompletion Page
 * Implemented as a practical sample.
 */
export const ResaleRaffleRepaymentCompletion: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleRaffleRepaymentCompletionTemplate state={state} {...actions} />
}
